export enum ContextOfUse {
    WorkflowAction = 'WorkflowAction',
    AutocompletionDatasource = 'AutocompletionDatasource',
}
